export const isGainNode = (audioNode) => {
    return !('frequency' in audioNode) && 'gain' in audioNode;
};
//# sourceMappingURL=gain-node.js.map